'use client';

/* eslint-disable @typescript-eslint/no-explicit-any */
import { type ComponentProps, useCallback } from 'react';

import { type Control, Controller, type ControllerProps, type FieldError } from '@/libs';

import { Input } from '../Input';

type InputFormProps = {
  control: Control<any>;
  name: string;
  error?: FieldError;
  formatFunction?(text: string): string | undefined;
  rules?: ControllerProps['rules'];
} & Omit<ComponentProps<typeof Input>, 'error' | 'value'>;

export const InputForm = ({
  control,
  name,
  error,
  formatFunction,
  rules,
  ...props
}: InputFormProps) => {
  const handleChange = useCallback(
    (text: string, onChange: (value: string | undefined) => void) => {
      if (formatFunction) {
        onChange(formatFunction(text));
        return;
      }
      onChange(text);
    },
    [formatFunction],
  );

  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({ field: { onChange, value } }) => (
        <Input
          id={name}
          value={value ?? ''}
          error={!!error}
          onChangeText={(text) => handleChange(text, onChange)}
          {...props}
        />
      )}
    />
  );
};
